<template>
  <Card class="shop-dashboard-widget-summary">
    <template #header>
      <div class="shop-dashboard-widget-summary__total">
        <label>{{ $t('totalPrice') }} ({{ $t('includingVat') }})</label>
        <div>{{ Currency($path('total.gross', shop)) }}</div>
      </div>
    </template>
    <template #default>
      <div class="shop-dashboard-widget-summary__scroll-wrapper">
        <Summary
          :toggle-state="true"
          :show-product-link="true"
          v-if="shop.id"
          :value="shop"
          class="shop-dashboard-widget-summary__summary"
        >
          <template #category-right="{ item }">
            <CategoryStatus :value="item" :shop="shop" style="float: right" />
          </template>
          <template #bottom>
            <ScrollIndicator :value="['top', 'bottom']" />
          </template>
        </Summary>
      </div>
    </template>
    <template #footer>
      <DropdownComponent class="shop-dashboard-widget-summary__export" :close-on-click="false">
        <ButtonComponent :icon="{ icon: ['fal', 'file-export'], size: 'lg' }" :label="$t('export')" />
        <template #dropdown="{ close }">
          <CheckboxComponent
            :value="exportData.selectedCategories.length === categories.length"
            @input="$ev => selectAll($ev)"
            :label="$t('selectAll')"
          />
          <hr />
          <CheckboxComponent
            v-for="item in categories"
            :key="item.id"
            :label="item.label"
            :state="item.id"
            v-model="exportData.selectedCategories"
          />
          <hr />
          <ButtonComponent
            tag="a"
            download
            :href="baseUrl + 'pdf?' + queryString"
            :label="$t('downloadX', { x: 'PDF' })"
            :icon="['fal', 'file-pdf']"
            @click="
              () => {
                onExport(close)
                track('ExportPDF')
              }
            "
          />
          <ButtonComponent
            tag="a"
            download
            :href="baseUrl + 'xlsx?' + queryString"
            :label="$t('downloadX', { x: 'Excel' })"
            :icon="['fal', 'file-excel']"
            @click="
              () => {
                onExport(close)
                track('ExportExcel')
              }
            "
          />
        </template>
      </DropdownComponent>
    </template>
  </Card>
</template>

<script>
import { mapState } from 'vuex'
import { Currency } from '@/filters'
import moment from 'moment'

import Card from '@/components/Card'
import { DropdownComponent } from 'vue-elder-dropdown'
import { CheckboxComponent } from 'vue-elder-checkbox'
import Summary from '@kvass/shop/src/Summary.vue'
import { InputComponent } from 'vue-elder-input'
import CategoryStatus from './CategoryStatus'

import ScrollIndicator from '@kvass/scroll-indicator'
import tracker from '@/tracking'

export default {
  provide() {
    return {
      getItemStatus: () => ({ isSelectable: false }),
    }
  },
  data() {
    return {
      exportData: {
        selectedCategories: [],
      },
    }
  },
  computed: {
    ...mapState('Shop', {
      shop: state => state.item,
      contract: state => state.item.contract || {},
    }),
    categories() {
      return this.shop.categories || []
    },
    baseUrl() {
      return `/api/shop/${this.shop.id}/document/`
    },
    queryString() {
      return new URLSearchParams({ categories: this.exportData.selectedCategories }).toString()
    },
  },
  methods: {
    track(v) {
      tracker.emit(`${v}:shop`)
    },
    selectAll(state) {
      if (state) this.exportData.selectedCategories = this.categories.map(c => c.id)
      else this.exportData.selectedCategories = []
    },
    onExport(close) {
      setTimeout(() => {
        this.selectAll(false)
      }, 0)
      close()
    },
    getCategoryStatus(item) {
      let partials = this.$path('contract.data.partials') || []
      let match = partials.find(p => p.reference === item.id)
      if (!match) return

      if (match.signableFrom && moment(match.signableFrom).isAfter(moment()))
        return this.$t('shopContractStatusUnsigned')
    },
    Currency(val) {
      return Currency(val, { currency: this.$path('project.metadata.currency', this.shop) })
    },
  },
  components: {
    Card,
    InputComponent,
    Summary,
    DropdownComponent,
    CheckboxComponent,
    CategoryStatus,
    ScrollIndicator,
  },
}
</script>

<style lang="scss">
.shop-dashboard-widget-summary {
  .shop-summary__total,
  .shop-summary__other-inquiries {
    display: none;
  }

  .shop-product-card {
    border: none;
    padding-top: 0;
    padding-bottom: 0;
  }

  .shop-summary {
    max-height: 750px;
    overflow-y: auto;

    @include scrollShadow();
  }

  &__scroll-wrapper {
    position: relative;
  }

  &__export {
    .elder-checkbox {
      padding: 0.25rem 0.75rem;

      &:first-child {
        padding-top: 0.75rem;
      }
    }
  }

  & > .card__content {
    padding: 2rem;
  }

  &__total {
    text-align: center;

    label {
      margin-bottom: 0.5rem;
      font-weight: normal;
    }

    div {
      font-size: 1.5em;
      font-weight: bold;
    }
  }

  td {
    padding: 1.25rem 0 !important;
  }

  tr:first-child td {
    padding-top: 0 !important;
  }

  .shop-summary__subcategory {
    td {
      border-top: 1px solid var(--border-color);
    }
  }
}
</style>
